module.exports = __webpack_public_path__ + "static/img/4.811d31c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/4.png
// module id = jgbk
// module chunks = 0